<template>
  <modal :name="name"
         :adaptive="true"
         height="auto"
         width="380"
         @before-open="beforeOpen"
         @before-close="beforeClose">
    <div v-if="prospect" class="ut-px-6 ut-pt-10 ut-pb-8 sm:ut-px-8">
      <div v-show="page == 1">
        <h2 class="title">Contact {{ $options.filters.titleCase(prospect.contact.firstName) }}
                        {{ $options.filters.titleCase(prospect.contact.lastName) }}</h2>
        <hr>
        <div v-if="prospect.data[0].contactPropertyAddress">
          <div class="address">
            <img class="ut-align-middle ut-mr-4 ut-ml-0"
                src="@/assets/styles/frontend-library/images/pin.svg">
            {{ $options.filters.address(prospect.data[0].contactPropertyAddress) }}
          </div>
          <hr>
          <div class="property-details">
            <span v-if="prospect.data[0].contactPropertyAddress.propertyTypeId === 1"
                  class="ut-ml-0">
              <img class="ut-align-middle ut-mr-4"
                src="@/assets/styles/frontend-library/images/icon-house.svg">
              House
            </span>
            <span v-if="prospect.data[0].contactPropertyAddress.propertyTypeId === 2"
                  class="ut-ml-0">
              <img class="ut-align-middle ut-mr-4"
                src="@/assets/styles/frontend-library/images/unit.svg">
              Apartment
            </span>
            <span v-if="prospect.data[0].contactPropertyAddress.propertyTypeId === 3"
                  class="ut-ml-0">
              <img class="ut-align-middle ut-mr-4"
                src="@/assets/styles/frontend-library/images/icon-land.svg">
              Land
            </span>
            <ul class="ut-mr-0">
              <li v-if="prospect.data[0].contactPropertyAddress.beds">
                <img src="@/assets/styles/frontend-library/images/bed.svg">
                {{ prospect.data[0].contactPropertyAddress.beds }}
              </li>
              <li v-if="prospect.data[0].contactPropertyAddress.baths">
                <img src="@/assets/styles/frontend-library/images/bath.svg"> 2
              </li>
              <li v-if="prospect.data[0].contactPropertyAddress.cars">
                <img src="@/assets/styles/frontend-library/images/car.svg"> 1
              </li>
            </ul>
          </div>
        </div>
        <hr>
        <div class="contact-details">
          <ul>
            <li v-if="prospect.contact.phone">
              <img
                class="ut-align-middle ut-mr-4"
                src="@/assets/styles/frontend-library/images/icon-phone.svg"
              >
              <Prospecting-click-to-show :email="false"
                        :str="prospect.contact.phone"
                        :formate="hasAttempted"
                        v-gaEvent="{ category: gacategory,
                               action: 'Contact card - Phone'}"
                        @clicked-show="showContactInfo('phone number')" />
            </li>
            <li v-if="prospect.contact.email">
              <img class="ut-align-middle ut-mr-4"
                src="@/assets/styles/frontend-library/images/mail.svg">

              <Prospecting-click-to-show :email="true"
                        :str="prospect.contact.email"
                        :formate="hasAttempted"
                        v-gaEvent="{ category: gacategory,
                               action: 'Contact card - email'}"
                        @clicked-show="showContactInfo('email address')" />
            </li>
          </ul>
        </div>

        <div class="ut-pt-6">
          <button @click="markProspectAsContacted(page)"
                  v-bind:class="{ disabled: !hasAttempted }"
                  v-gaEvent="{ category: gacategory,
                               action: 'Contact card - mark as contacted'}"
                  class="btn btn-green">Mark as contacted</button>
          <button @click="createAttempt()"
                  v-bind:class="{ disabled: !hasAttempted }"
                  v-gaEvent="{ category: gacategory,
                               action: 'Contact card - mark as attempted'}"
                  class="btn btn-small white-bg ut-ml-4">I called, no answer</button>
        </div>

      </div>

      <div v-show="page == 2" class="ut-text-center ut-px-3">
        <img class="ut-mb-8" src="@/assets/images/contacted.svg">
        <h2 class="title">{{ $options.filters.titleCase(prospect.contact.firstName) }}
            {{ $options.filters.titleCase(prospect.contact.lastName) }} has been contacted</h2>
        <p class="ut-mb-6">
            What was the outcome of the call?</p>
        <ul class="option-list">
          <li @click="loadNextModal('prospecting-appraisal-modal')">
            <div class="ut-form-radio">
              <input type="radio" id="radio-appraisal">
              <label for="radio-appraisal">I booked an appraisal</label>
            </div>
          </li>
          <li @click="loadNextModal('prospecting-follow-up-modal')">
            <div class="ut-form-radio">
              <input type="radio" id="radio-follow-up">
              <label for="radio-follow-up">I need a reminder to follow up</label>
            </div>
          </li>
          <li @click="loadNextModal('prospecting-remove-prospect-modal')">
            <div class="ut-form-radio">
              <input type="radio" id="radio-delete">
              <label for="radio-delete">Vendor not interested</label>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapActions } from 'vuex';
import ProspectingClickToShow from '@/components/ProspectingClickToShow.vue';

export default {
  name: 'ProspectingContactModal',
  components: {
    ProspectingClickToShow,
  },
  props: {
    agentId: {
      required: true,
    },
  },
  data() {
    return {
      name: 'prospecting-contact-modal',
      page: 1,
      callOutcome: null,
      prospect: null,
      gacategory: 'Prospecting Tool Agent portal',
      // hasAttempted: false,
    };
  },
  computed: {
    hasAttempted() {
      if (!this.prospect.stages) {
        return false;
      }

      // Requested vendor details, Attempted or Contacted
      const filter = this.prospect.stages.filter(p => p.stageTypeId === 7 || p.stageTypeId === 1 || p.stageTypeId === 6);
      return filter.length !== 0;
    },
  },
  methods: {
    ...mapActions('prospectsStore', [
      'updateProspect',
      'reloadProspectLists',
    ]),
    closeModal() {
      this.page = 1;
      this.$modal.hide(this.name);
    },
    beforeOpen(event) {
      this.page = 1;
      this.prospect = event.params;
      if (!this.prospect.stages) {
        this.prospect.stages = [];
      }
    },
    beforeClose() {
      if (this.$route.params.pk) {
        this.$router.push({
          name: 'prospecting',
          params: { ak: this.$route.params.ak },
        });
      }
    },
    loadNextModal(modalName) {
      this.$modal.show(modalName, this.prospect);
      this.closeModal();
    },
    markProspectAsContacted(currentPage) {
      // If this prospected was already marked as contacted
      if (!this.prospect.contacted) {
        const payload = {
          agentId: this.agentId,
          prospectKey: this.prospect.key,
          data: {
            contacted: true,
          },
        };
        this.updateProspect(payload).then(() => {
          const reloadData = {
            agentId: this.agentId,
            current: 'toCall',
            new: this.prospect.currentList !== 'contacted' ? 'contacted' : null,
          };

          this.reloadProspectLists(reloadData);

          this.page = currentPage + 1;
        });
      } else {
        this.page = currentPage + 1;
      }
    },
    createAttempt() {
      const payload = {
        agentId: this.agentId,
        prospectKey: this.prospect.key,
        data: {
          attempted: true,
          attemptedDate: this.$helpers.formatDateTimeApi(new Date()),
        },
      };

      console.log(payload);

      this.updateProspect(payload).then(() => {
        const reloadData = {
          agentId: this.agentId,
          current: this.prospect.currentList,
        };

        this.reloadProspectLists(reloadData);
        this.closeModal();
      });
    },
    showContactInfo(contactType) {
      const payload = {
        agentId: this.agentId,
        prospectKey: this.prospect.key,
        data: {
          requestedVendorContactDetails: true,
          requestedVendorContactDetailsNote: `Clicked Prospect ${contactType}`,
        },
      };

      this.updateProspect(payload).then(() => {
        this.prospect.stages.push({ stageTypeId: 7 });

        const reloadData = {
          agentId: this.agentId,
          current: this.prospect.currentList,
        };
        this.reloadProspectLists(reloadData);
      });
    },
  },
};
</script>

<style scoped lang="scss">
.title {
  @apply ut-font-bold ut-mb-6;
  font-size: 20px;

}

.disabled {
  @apply ut-opacity-50;
  cursor: not-allowed !important;
  pointer-events: none !important;
}

hr {
  @apply ut-border-t ut-opacity-50 ut-w-full ut-h-auto;
  border-color: #979797;
}

.address {
  @apply ut-my-6 ut-flex ut-font-bold;
}

.property-details {
  @apply ut-flex ut-my-6;

  ul {
    @apply ut-flex;

    li {
      @apply ut-ml-6;

      img {
        vertical-align: sub;
      }
    }
  }
}

.contact-details {
  @apply ut-my-6;

  ul {
    li {
      @apply ut-my-6;

      a {
        @apply ut-text-green-400;
      }
    }
  }
}

.option-list {
  @apply ut-text-left ut-px-4;

  li {
    @apply ut-my-3;
  }
}

.ut-form-radio {

  input {
      appearance: none;
      display: inline-block;
      position: relative;
      background-color: #ffffff;
      color: #11AB5E;
      height: 20px;
      width: 20px;
      cursor: pointer;
      outline: none;
      @apply ut-rounded-full ut-border-solid ut-border-2 ut-align-top ut-mr-3;
      border-color:#11AB5E;


      &:checked::before {
          content: '';
          @apply ut-rounded-full ut-absolute ut-m-auto ut-inset-x-0 ut-bg-green-400;
          top: 2px;
          height: 12px;
          width: 12px;
      }

      &:hover {
        box-shadow: 0px 0px 0px 10px rgba(37, 186, 104, 0.3);
        background-color: rgba(37, 186, 104, 0.3);
      }
  }

  label {
    color: #545352;
    font-size: 14px;
    line-height: 20px;
    cursor: pointer;
  }

}

</style>
